<template>
    <div>
        <div v-for="(item,i) in content" style="width:355px;margin:0 auto">
            <img  style="width:355px;" v-if="item.pic.length==0"  src="https://api-xiangyou.dierqudao.com/public/images/no-pic.png" alt="" srcset="">
            <img  style="width:355px;" v-else :src='item.pic[0].url'>
            <!-- <img style="width:355px;" :src="item.pic[0].url" alt="" srcset=""> -->
        </div>
    </div>
</template>

<script> 
    export default {
        name: "Pic",
        components: {
        },
        props: {
            content: {
                type: Array,
                default: [],
            },

        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>

</style>